<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listSocialSecurityGroup"
        :title-table="$t('Social Security Group')"
        module="socialSecurityGroupSettingsModule"
        sort-name="nome"
        add-permission="ROLE_GRUPO_PREVIDENCIA_SOCIAL_INSERIR"
        view-permission="ROLE_GRUPO_PREVIDENCIA_SOCIAL_CONSULTAR"
        edit-permission="ROLE_GRUPO_PREVIDENCIA_SOCIAL_ATUALIZAR"
        delete-permission="ROLE_GRUPO_PREVIDENCIA_SOCIAL_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormSocialSecurityGroup v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormSocialSecurityGroup from "./forms/FormSocialSecurityGroup.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormSocialSecurityGroup,
  },
  computed: {
    ...mapState("socialSecurityGroupSettingsModule", {
      listSocialSecurityGroup: (state) => state.listSocialSecurityGroup,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "socialSecurityGroupSettingsModule/prepareToEditSocialSecurityGroup",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
